import { render, staticRenderFns } from "./ModAl.vue?vue&type=template&id=0b33560b"
import script from "./ModAl.vue?vue&type=script&lang=js"
export * from "./ModAl.vue?vue&type=script&lang=js"
import style0 from "./ModAl.vue?vue&type=style&index=0&id=0b33560b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports